document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(function (accordion) {
    var items = accordion.querySelectorAll('.swm26-accordion__item');

    items.forEach(function (item) {
      var trigger = item.querySelector('.swm26-accordion__trigger');
      var content = item.querySelector('.swm26-accordion__content-wrap');

      if (!trigger || !content) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          var otherTrigger = otherItem.querySelector('.swm26-accordion__trigger');
          var otherContent = otherItem.querySelector('.swm26-accordion__content-wrap');

          otherItem.classList.remove('is-open');

          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }

          if (otherContent) {
            otherContent.style.display = 'none';
          }
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          content.style.display = 'block';
        }
      });
    });
  });
});